import React from 'react';
import Footer from './Footer';
import Intro from './Intro';
import About from './About';
import Statement from './Statement';
import Club from './Club';
import Statement2 from './Statement2';
import Blog from './Blog';
import Chat from './Chat';
import Task from './Task';
import Contact from './Contact';
import Fade from 'react-reveal';

export default function Home(){
    return(
        <>
            <Fade top distance = '10%' duration = {1000}>
                <Intro />
                <About />
                <Statement/>
                <Club />
                <Statement2 />
                <Blog />
                <Chat />
                <Task />
                <Contact />
                <Footer />
            </Fade>
        </>
    );
}